import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SourceNewComponent } from '../source-new.component';
import { SourceCitationViewModel } from 'src/app/common/models/sourceCitation/source-citation-view-model';
import { EventApiService } from 'src/app/services/API/event-api.service';
import { MessageDialogService } from '../../../message-dialog/services/message-dialog.service';
import { SourceAPIService } from 'src/app/services/API/source-api.service';
import { LoadingService } from 'src/app/services/UI/loading.service';
import { TranslateHandler } from 'src/app/common/helpers/translate-handler';
import { SourceComponentModel } from 'src/app/common/models/source/source-component-model';
import { EventViewBase } from '../../../events/models/event-view-base';
import { Multimedia } from 'src/app/common/models/multimedia/multimedia';
import { DropMenuAction, MultimediaTypes, NotifierEvents, PopupViewMode, ReferenceType } from 'src/app/common/enums/enums';
import { GuidGenerator } from 'src/app/common/helpers/guid-generator';
import { CustomError } from 'src/app/common/helpers/custom-error';
import { ResponseModel } from 'src/app/common/models/ResponseModel';
import { DialogService } from 'src/app/services/UI/dialog.service';
import { NgForm } from '@angular/forms';
import { ComponentBase } from '../../../base/component-base';
import { NotifierV2Service } from 'src/app/services/notifier-v2.service';

@Component({
  selector: 'app-source-editor-new',
  templateUrl: './source-editor-new.component.html',
  styleUrls: ['./source-editor-new.component.scss']
})
export class SourceEditorNewComponent extends ComponentBase implements OnInit {
  expectedUpdates = [NotifierEvents.RootMemberChanged];
  @ViewChild('f') form: NgForm;
  

  constructor(
    private dialogService: DialogService,
    private translateHandler: TranslateHandler,
    private loadingService: LoadingService,
    private sourceApiService: SourceAPIService,
    private messageDialogService: MessageDialogService,
    private eventApiService: EventApiService,
    notifierService: NotifierV2Service
  ) {
    super(notifierService);
  }

  @Input() data;
  @Output() onCompleted = new EventEmitter<any>();

  titleTxt: any;
  sourceComponentModel: SourceComponentModel;
  eventList: EventViewBase[];
  defaultCarouselImage: string = "/assets/images/icons/source.svg";
  eventConfig: any;
  isDirty: boolean = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && this.data?.editSourceId > 0) {
      this.loadSource(this.data.editSourceId);
    }
    if (changes['data'] && this.data?.editSourceId == 0) {
      this.resetForm();
    }
  }

  loadSource(sourceId: number) {
    let processId = GuidGenerator.generate();
    this.loadingService.show(processId);

    this.sourceApiService.getSourceById(sourceId).subscribe((response: ResponseModel<SourceComponentModel>) => {
      this.sourceComponentModel = response.data;
      this.getEventForSource();
    }).add(() => {
      this.loadingService.hide(processId);
    });
  }
  ngOnInit(): void {
    this.sourceComponentModel = new SourceComponentModel();
    this.sourceComponentModel.multimedias = new Array<Multimedia>();
    this.eventConfig = {
      message: this.translateHandler.translate('err_no_event_for_resource', [this.translateHandler.translate('lbl_source').toLowerCase()]),
      referenceType: ReferenceType.Source
    }

    this.titleTxt = this.translateHandler.translate('lbl_link_media', [this.translateHandler.translate("lbl_source").toLowerCase(), this.data.titleText]);

    if (this.data.editSourceId > 0) {
      // Call Get API
      let processId = GuidGenerator.generate();
      this.loadingService.show(processId);

      this.sourceApiService.getSourceById(this.data.editSourceId).subscribe((response: ResponseModel<SourceComponentModel>) => {
        this.sourceComponentModel = response.data;
        this.getEventForSource();

      }, (err) => {
        throw new CustomError("SourceEditorComponent => getSourceById() : " + err, 911, false);
      }).add(() => {
        this.loadingService.hide(processId);
      });
    }
    else {
      this.sourceComponentModel.id = 0;
    }
  }

  getEventForSource() {
    let processId = GuidGenerator.generate();
    this.loadingService.show(processId);

    this.eventApiService.getEventForSourceById(this.data.editSourceId).subscribe((response: ResponseModel<EventViewBase[]>) => {
      this.eventList = response.data;
      // this.data.editorMode = 3;
    }, (err) => {
      throw new CustomError("SourceEditorComponent => getEventForSource() : " + err, 911, false);
    }).add(() => {
      this.loadingService.hide(processId);
    });
  }

  carouselActionClicked($event) {
    let selectedMultimedia = $event.reference;
    let action = $event.action;

    if (action === DropMenuAction.Edit) {
      this.addImage(selectedMultimedia.id, 2);
    }
    if (action === DropMenuAction.Unlink) {
      let unlinkMessage = this.translateHandler.translate("cnf_unlink_image_from_source_confirmation_message");
      this.messageDialogService.openUnlinkfirmation(unlinkMessage).subscribe((res: boolean) => {
        if (res) {
          this.unlinkImage(selectedMultimedia);
        }
      });
    }
    if (action === DropMenuAction.SetAsPrimary) {
      this.setImageAsPrimary(selectedMultimedia);
    }
    if (action === DropMenuAction.Upload) {
      this.addImage(0, 2);
    }
    if (action === DropMenuAction.Gallery) {
      this.addImage(0, 1);
    }
  }

  addImage(mediaId: any, viewMode: any) {
    this.dialogService.open("Multimedia",
      {
        id: this.sourceComponentModel.multimedias?.find(m => m.isPrimary)?.id ?? 0,
        reference: {
          id: this.sourceComponentModel.id, //Source Id
          type: ReferenceType.Source
        },
        title: this.translateHandler.translate('lbl_link_media', [this.translateHandler.translate("lbl_media"), this.translateHandler.translate("lbl_source")]), // media for place for + <name>        
        mediaType: [MultimediaTypes.PHOTO],
        viewMode: viewMode,
        editMediaId: mediaId,
        isStandAlone: false
      }
    ).subscribe((response) => {
      if (response.data) {
        response.data.deleteMedias.forEach(element => {
          let index = this.sourceComponentModel.multimedias.findIndex(m => m.id === element.id);
          if (index >= 0) {
            this.sourceComponentModel.multimedias.splice(index, 1);
            this.setNextImageAsPrimary(index);
          }
        });
        if (response.data.newMedia) {
          response.data.newMedia.isNewlyAdded = true;
          let mediaIndex = this.sourceComponentModel.multimedias?.findIndex(t => t.id == response.data.newMedia.id) ?? -1;
          !this.sourceComponentModel.multimedias ? this.sourceComponentModel.multimedias = new Array<Multimedia>() : null;
          if (mediaIndex < 0)
            this.sourceComponentModel.multimedias.push(response.data.newMedia);
          else {
            this.sourceComponentModel.multimedias[mediaIndex] = response.data.newMedia;
          }
          // When adding new image to image carousel , set this as primary
          this.sourceComponentModel.multimedias.map(m => m.isPrimary = m.id === response.data.newMedia.id);
          this.isDirty = true;
        }
      }
    });
  }

  unlinkImage(selectedMultimedia: Multimedia) {
    if (selectedMultimedia != null) {
      let index = this.sourceComponentModel.multimedias.findIndex(i => i.id === selectedMultimedia.id);
      this.sourceComponentModel.multimedias.splice(index, 1);
      this.setNextImageAsPrimary(index);
      this.isDirty = true;
    }
  }

  setImageAsPrimary(selectedMultimedia: Multimedia) {
    if (selectedMultimedia != null) {
      if (!selectedMultimedia.isPrimary) {
        this.sourceComponentModel.multimedias.map(m => m.isPrimary = m.id === selectedMultimedia.id);
        this.isDirty = true;
      }
    }
  }

  setNextImageAsPrimary(index: number) {
    let isPrimaryImage = this.sourceComponentModel.multimedias?.find(t => t.isPrimary == true) ?? null;
    if (!isPrimaryImage && this.sourceComponentModel.multimedias?.length > 0) {
      if (this.sourceComponentModel.multimedias[index > 0 ? (index - 1) : 0].isNonProfile) {
        this.sourceComponentModel.multimedias.find(m => m.mediaType == MultimediaTypes.PHOTO && !m.isNonProfile).isPrimary = true;
      } else {
        this.sourceComponentModel.multimedias[index > 0 ? (index - 1) : 0].isPrimary = true;
      }
    }
  }

  addSource() {
    let processId = GuidGenerator.generate();
    this.loadingService.show(processId);

    if (this.data.editSourceId == 0) {
      // Create Source API
      this.sourceApiService.createSource(this.sourceComponentModel).subscribe((response: ResponseModel<SourceComponentModel>) => {
        this.loadingService.hide(processId);
        this.sourceComponentModel.id = response.data.id;
      }, (err) => {
        throw new CustomError("SourceEditorComponent => createSource() : " + err, 911, false);
      }).add(() => {
        this.loadingService.hide(processId);
        this.completeAction();
      });
    }
    else {
      // Update Source API
      this.sourceApiService.updateSource(this.sourceComponentModel).subscribe((response: ResponseModel<SourceComponentModel>) => {
      }, (err) => {
        throw new CustomError("SourceEditorComponent => updateSource() : " + err, 911, false);
      }).add(() => {
        this.loadingService.hide(processId);
        this.completeAction();
      });
    }
  }

  completeAction() {
    this.onCompleted.emit({ data: this.sourceComponentModel });
    this.data.editSourceId = 0;
    this.resetForm();
  }

  resetForm() {
    this.sourceComponentModel = new SourceComponentModel();
    this.sourceComponentModel.multimedias = [];
    this.eventList = [];
    this.isDirty = false;
    if (this.form) {
      this.form.resetForm();
    }
  }

  cancel() {
    this.data.editSourceId = 0;
    this.resetForm();
    this.onCompleted.emit({ data: new SourceComponentModel() });
  }

  notify() {
    this.resetForm();
  }

  public canChange(): boolean {
    return !this.isDirty;
  }
}
